import reduxQuerySync from 'redux-query-sync';

import { UPDATE_BETTING_ODDS } from '../../../store/js/modules/brownlow-tracker/leaderboard/actions';
import { leaderboardBettingOddsSelector } from '../../../store/js/modules/brownlow-tracker/leaderboard/selectors';

export const configureReduxQuerySync = (store) => {
    return reduxQuerySync({
        store,
        params: {
            bettingOdds: {
                selector: (state) =>
                    leaderboardBettingOddsSelector(state)?.isActive,
                action: (isActive) => {
                    return UPDATE_BETTING_ODDS.request({ isActive });
                },
                stringToValue: (isActive) => isActive === 'true',
                defaultValue: false
            }
        },

        // Initially set the store's state to the current location.
        initialTruth: 'location'
    });
};
